import CaretBottomIcon from 'assets/icons/landing/caret-bottom'
import MouseIcon from 'assets/icons/landing/mouse'
import PaperIcon from 'assets/icons/landing/paper'
import damuLogoDark from 'assets/images/landing/damu-logo-dark.png'
import damuLogoLight from 'assets/images/landing/damu-logo-light.png'
import mainVideoMov from 'assets/images/landing/main-video.mov'
import mainVideoWebm from 'assets/images/landing/main-video.webm'
import Blurred from 'components/UI/Landing/blurred'
import PrimaryButton from 'components/UI/Landing/button-primary'
import LandingContainer from 'components/UI/Landing/container'
import SectionTitle from 'components/UI/Landing/section-title'
import SubTitle from 'components/UI/Landing/subtitle'
import PrimaryText from 'components/UI/Landing/text-primary'
import WithGradient from 'components/UI/Landing/with-gradient'
import { useTheme } from 'contexts/theme-context'
import { useTranslation } from 'react-i18next'

export default function MainSection() {
  // Tools
  const { t } = useTranslation(['landing'])

  // Context
  const { isDarkTheme } = useTheme()

  return (
    <section className='relative pb-[110px] p-0 lg:pt-[88px]'>
      <LandingContainer>
        <div className='flex flex-col-reverse lg:flex-row items-center justify-between lg:gap-5 '>
          <div className='z-10 mt-4 lg:mt-0'>
            <SectionTitle title={t('main-section.title')} className='sm:text-[40px] sm:leading-[56px]' />
            <div className='flex gap-x-4 sm:gap-x-8 mt-4'>
              <div className='flex flex-col gap-8'>
                <div className='flex flex-col gap-2 min-w-[150px]'>
                  <SubTitle title={t('loan.loan-text', { ns: 'common' })} className='tet-base leading-[22px]' />
                  <PrimaryText
                    text={t('interpolations.loan-limit', { ns: 'common', amount: 100 })}
                    className='text-lg leading-[22px] text-[var(--text-landing-green)] '
                  />
                </div>
              </div>
              <div className='flex flex-col gap-8'>
                <div className='flex flex-col gap-2 min-w-[150px]'>
                  <SubTitle title={t('loan.period', { ns: 'common' })} className='tet-base leading-[22px]' />
                  <PrimaryText
                    text={t('interpolations.period-limit', { ns: 'common', period: 5 })}
                    className='text-lg  text-[var(--text-landing-green)] leading-[22px]'
                  />
                </div>
              </div>
            </div>
            <PrimaryButton
              type='button'
              className='w-full sm:w-auto lg:block mt-8'
              onClick={() => {
                window.scrollTo({
                  behavior: 'smooth',
                  top: 800
                })
              }}
            >
              {t('main-section.btn-text')}
            </PrimaryButton>
          </div>
          <div className='relative w-5/6 sm:w-[65%] bvi-hide'>
            <video
              className='w-full z-10 relative min-h-[350px] max-h-[350px] md:min-h-[605px] md:max-h-[605px]'
              playsInline
              autoPlay
              muted
              loop
              id='section-video'
            >
              <source src={mainVideoMov} type='video/quicktime' />
              <source src={mainVideoWebm} type='video/webm' />
            </video>
            <Blurred className='absolute z-20 right-[55%] sm:right-54 top-10 '>
              <PrimaryText text={t('main-section.absolute-online')} className='whitespace-nowrap' />
            </Blurred>
            <Blurred className='absolute z-20 top-[20%] md:top-[38%] -right-8 !rounded-2xl '>
              <div className='flex items-center gap-3'>
                <PaperIcon tw='w-6 h-6' />
                <PrimaryText text={t('main-section.without-docs')} className='w-24 text-sm sm:text-lg sm:w-32' />
              </div>
            </Blurred>
            <Blurred className='absolute z-20 bottom-[42%] -left-4 md:bottom-[22%] md:left-[8%]'>
              <img
                src={isDarkTheme ? damuLogoLight : damuLogoDark}
                className='w-[95px] sm:w-[100px] sm:min-w-[100px]'
                alt='DAMU_LOGO'
              />
            </Blurred>
            <WithGradient className='w-[150px] h-[200px] sm:w-[250px] sm:h-[300px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute rounded-full pacity-60 blur-[115px] z-0 sm:-rotate-45 ' />
          </div>
        </div>
      </LandingContainer>

      <button className='hidden absolute pb-28 inset-x-auto bottom-[0] left-[50%] md:flex flex-col items-center justify-center gap-2 bvi-hide'>
        <MouseIcon />
        <CaretBottomIcon />
      </button>
    </section>
  )
}
